import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import styled, { css } from 'styled-components';
import { variant as styleVariant } from 'styled-system';
import { Icon } from '..';
import { get } from '../../styles/constant';
import { spinnerAnimationStyled } from '../LoadingIndicator/loading-indicator.style';
const appearances = styleVariant({
  variants: {
    "default": {
      borderStyle: 'solid',
      boxShadow: 'none',
      backgroundColor: get('colors.functional.grey[50]'),
      borderColor: get('colors.functional.grey.400'),
      '&:focus, &:active': {
        outline: 'none',
        boxShadow: get('boxShadows.components.select.default'),
        borderColor: get('colors.primary.blue.400')
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: props => "".concat(get('colors.functional.grey.100')(props), "80"),
        borderColor: props => "".concat(get('colors.functional.grey.400')(props), "80"),
        color: props => "".concat(get('colors.functional.grey.800')(props), "80")
      }
    },
    vanity: {
      borderLeft: get('space.0'),
      borderRight: get('space.0'),
      borderRadius: get('space.0'),
      backgroundColor: 'transparent',
      paddingLeft: get('space.0'),
      paddingRight: get('space.20'),
      borderColor: get('colors.functional.grey.400'),
      borderTop: '1px solid transparent',
      '&:focus, &:active': {
        outline: 'none',
        boxShadow: get('boxShadows.components.select.vanityDefault'),
        borderBottomColor: get('colors.primary.blue.400'),
        borderTop: '1px solid transparent'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: props => "".concat(get('colors.functional.grey.100')(props), "80"),
        borderBottomColor: props => "".concat(get('colors.functional.grey.400')(props), "80"),
        color: props => "".concat(get('colors.functional.grey.900')(props), "80")
      }
    },
    multiple: {
      height: 'unset',
      padding: get('space.12'),
      '&:focus, &:active': {
        outline: 'none',
        boxShadow: get('boxShadows.components.select.default'),
        borderColor: get('colors.primary.blue.400')
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: props => "".concat(get('colors.functional.grey.100')(props), "80"),
        borderColor: props => "".concat(get('colors.functional.grey.400')(props), "80"),
        color: props => "".concat(get('colors.functional.grey.900')(props), "80")
      }
    }
  }
});
const fit = styleVariant({
  prop: 'fit',
  variants: {
    small: {
      height: get('space.32'),
      fontSize: get('fontSizes.14')
    },
    medium: {
      height: get('space.40'),
      fontSize: get('fontSizes.16')
    },
    large: {
      height: get('space.48'),
      fontSize: get('fontSizes.16')
    }
  }
});
const customOrientation = styleVariant({
  prop: 'orientation',
  variants: {
    horizontal: {
      marginRight: get('space.6')
    },
    vertical: {
      marginBottom: get('space.4')
    }
  }
});
const iconPosition = styleVariant({
  prop: 'fit',
  variants: {
    small: {
      bottom: get('space.4'),
      right: get('space.8')
    },
    medium: {
      bottom: get('space.10'),
      right: get('space.12')
    },
    large: {
      bottom: get('space.12'),
      right: get('space.16')
    }
  }
});
const variants = {
  appearances,
  fit,
  customOrientation,
  iconPosition
};
export const StyledSelect = styled.select.attrs(_ref => {
  let {
    multiple
  } = _ref;
  return {
    multiple: multiple
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  appearance: none;\n  width: 100%;\n  color: ", ";\n  ", ";\n  ", ";\n\n  ", "\n\n  ", "\n  ", "\n"])), get('colors.functional.grey[900]'), variants.appearances, variants.fit, _ref2 => {
  let {
    fit,
    variant
  } = _ref2;
  return variant === 'default' && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      border-radius: ", ";\n      padding: ", ";\n    "])), fit === 'small' ? get('borderRadius.s') : get('borderRadius.m'), fit === 'small' ? "".concat(get('space.0')(fit), " ").concat(get('space.32')(fit), " ").concat(get('space.0')(fit), " ").concat(get('space.8')(fit)) : fit === 'medium' ? "".concat(get('space.0')(fit), " ").concat(get('space.36')(fit), " ").concat(get('space.0')(fit), " ").concat(get('space.12')(fit)) : "".concat(get('space.0')(fit), " ").concat(get('space.48')(fit), " ").concat(get('space.0')(fit), " ").concat(get('space.16')(fit)));
}, _ref3 => {
  let {
    invalid,
    variant
  } = _ref3;
  return invalid && variant !== 'vanity' && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      border-color: ", ";\n      &:focus,\n      &:active {\n        outline: none;\n        box-shadow: ", ";\n      }\n    "])), get('colors.feedback.danger.normal'), get('boxShadows.components.select.danger'));
}, _ref4 => {
  let {
    invalid,
    variant
  } = _ref4;
  return invalid && variant === 'vanity' && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      border-bottom-color: ", ";\n      &:focus,\n      &:active {\n        outline: none;\n        box-shadow: ", ";\n        border-bottom-color: ", ";\n      }\n    "])), get('colors.feedback.danger.normal'), get('boxShadows.components.select.vanityDanger'), get('colors.feedback.danger.normal'));
});
export const StyledSelectIcon = styled(Icon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  pointer-events: none;\n  color: ", ";\n  ", ";\n"])), get('colors.functional.grey.600'), variants.iconPosition);
export const LoadingIndicator = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  right: ", ";\n  top: ", ";\n  & svg {\n    animation: ", ";\n    height: ", ";\n    width: ", ";\n  }\n  & .spinner {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n  & .track {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n"])), get('space.36'), get('space.0'), spinnerAnimationStyled, props => props.fit === 'small' ? get('space.16') : get('space.20'), props => props.fit === 'small' ? get('space.16') : get('space.20'), get('colors.primary.blue.300'), get('colors.functional.grey.200'));
export const LabelContent = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export const LabelTooltip = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), get('space.4'));